<div class="modal-header">
  <h3 class="modal-title">{{"AufbereitungsoptionenEigentuemerAuszug" | translate}}</h3>
  <button (click)="activeModal.close(false)" aria-label="Close" class="btn-close" type="button"></button>
</div>

<div class="modal-body">
  <div class="container-fluid ms-0 ps-0 me-0 pe-0">
    <form #form="ngForm" column-classes="col-md-2,col-md-10">
      <h2>{{ "Eigentuemer" | translate }}: {{ title }}</h2>

      <br />
      <h3 class="title-divider">{{"Inhalt" | translate}}</h3>

      <cap-form-control labelKey="AdressenAufbereiten">
        <input [(ngModel)]="options.adresseAufbereiten" name="AdressenAufbereiten" type="checkbox" />
      </cap-form-control>
      @if (hasToZip) {
        <cap-form-control labelKey="AuszugBearbeiten">
          <input
            (ngModelChange)="options && (options.auszugBearbeiten = $event)"
            [disabled]="options.inEinemDokumentDrucken"
            [ngModel]="options && options.auszugBearbeiten"
            name="AuszugBearbeiten"
            type="checkbox" />
        </cap-form-control>
      }
      @if (hasRequiredErweiterung && hasToZip) {
        <cap-form-control labelKey="InEinemDokumentDrucken">
          <input
            (ngModelChange)="options && (options.inEinemDokumentDrucken = $event)"
            [disabled]="options.auszugBearbeiten"
            [ngModel]="options && options.inEinemDokumentDrucken"
            name="InEinemDokumentDrucken"
            type="checkbox" />
        </cap-form-control>
      }
      <cap-form-control labelKey="UidBeiNatuerlichenPersonenDrucken">
        <input [(ngModel)]="options.uidBeiNatuerlichenPersonenDrucken" name="UidBeiNatuerlichenPersonenDrucken" type="checkbox" />
      </cap-form-control>

      <br />
      @if (showFormatSelection) {
        <br />
        <h3 class="title-divider">{{"Dateiformat" | translate}}</h3>
        <div class="mt-2">
          <div class="btn-group" data-toggle="buttons">
            <label [ngClass]="{ active: format === 'PDF' }" class="btn btn-outline-secondary">
              <input [(ngModel)]="format" class="btn-check" id="formatPDF" name="format" type="radio" value="PDF" /> PDF
            </label>
            <label [ngClass]="{ active: format === 'RTF' }" class="btn btn-outline-secondary">
              <input [(ngModel)]="format" class="btn-check" id="formatRTF" name="format" type="radio" value="RTF" /> RTF
            </label>
          </div>
        </div>
      }
      <br />
    </form>
  </div>
</div>
<div class="modal-footer">
  <button (click)="activeModal.close(false)" class="btn btn-outline-primary" type="button">{{ "Abbrechen" | translate }}</button>
  <button (click)="confirm()" [disabled]="!format" class="btn btn-primary" type="submit">{{ "AuszugErstellen" | translate }}</button>
</div>
